import axios from "axios";
let CryptoJs = require("crypto-js");
const KEY: any = process.env.REACT_APP_ENCRYPTION_KEY;
const ERRORCODES = [400, 404];

/*Live Tomcat Server URLs */
//"https://www.cellmaflex.com/cellmaflexAPI/"
//"https://www.cellmaflex.com/CellmaFlex"

/*Test Tomcat Server URLs */
//"https://www.testcellmaflexdemo.com/cellmaflexAPI/"
//"https://www.testcellmaflexdemo.com/CellmaFlex"

/*Local URLs*/
//"http://localhost:8081/cellmaflexAPI/"
//"http://localhost:3000"

const baseURL = "https://www.cellmaflex.com/cellmaflexAPI/";
export const cellmaflexUrl = "https://www.cellmaflex.com/CellmaFlex";

export const getRequest = async (url: string, params: any) => {
  try {
    const response = await axios.get(baseURL + url, params);
    return response;
  } catch (error: any) {
    return handleError(error);
  }
};

export const postAxios = async (url: string, body: any, header: any) => {
  try {
    const response = await axios.post(baseURL + url, body, header);
    return response;
  } catch (error: any) {
    return handleError(error);
  }
};

export const putAxios = async (url: string, params: any) => {
  try {
    const response = await axios.put(baseURL + url, params);
    return response;
  } catch (error: any) {
    return handleError(error);
  }
};

export const deleteAxios = async (url: string, params: any) => {
  try {
    const response = await axios.post(baseURL + url, params);
    return response;
  } catch (error: any) {
    return handleError(error);
  }
};

const handleError = (error: any) => {
  if (
    error.response.data === "Incorrect Credentials" ||
    error.response.data === "User Not Found"
  ) {
    return "Incorrect Credentials";
  }
  if (
    error.toJSON().message === "Network Error" ||
    ERRORCODES.includes(error.response.status)
  ) {
    console.log(error.response);
    return "ERROR";
  } else if (
    error.response.status === 403 &&
    error.response.data !== undefined
  ) {
    return error.response.data;
  } else if (
    error.response.status === 500 &&
    error.response.data !== undefined
  ) {
    return error.response.data.exMessage;
  } else if (
    error.response.status === 401 &&
    error.response.data !== undefined
  ) {
    if (
      error.response.data.toString().includes("HTTP Status 401 – Unauthorized")
    ) {
      return "User has already been logged out!";
    }
    return error.response.data;
  } else {
    return "ERROR";
  }
};

export const singoutHandler = async (jwtToken: any) => {
  await getRequest("logoutUser", {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });
};

export const encryptedText = (text: string) => {
  return CryptoJs.AES.encrypt(text, KEY).toString();
};
